import * as React from 'react';
import ErrorDetailsView from '../ErrorDetailsView/ErrorDetailsView';
import HybridLink from '../HybridLink/HybridLink';
import type AppError from '../../../lib/AppError';
import cn from '~modules/cn';
import Styles from './inline-error-view.module.scss';
import IconInfo from '../../../assets/icons/v2design/basics/info.svg';

type Props = {
    error?: AppError;
    errorString: string;
    showIcon?: boolean;
    className?: string;
    dataTestId?: string;
};

const InlineErrorView = (props: Props) => {
    const { error, errorString, showIcon, className } = props;

    const [isDetailsVisible, setDetailsVisible] = React.useState(false);

    return (
        <div className={cn(className, Styles.container)} data-testid={props.dataTestId}>
            <div className={Styles.header}>
                {showIcon && <IconInfo className={Styles.icon} />}
                <div>
                    <span>{errorString}</span>
                    {error && (
                        <HybridLink className={Styles['details-button']} onClick={() => setDetailsVisible(!isDetailsVisible)}>
                            {isDetailsVisible ? 'Hide details' : 'See details'}
                        </HybridLink>
                    )}
                </div>
            </div>
            {isDetailsVisible && error && <ErrorDetailsView error={error} className={Styles['details-container']} />}
        </div>
    );
};

export default InlineErrorView;
